import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { HttpErrorResponse, HttpEventType } from '@angular/common/http';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { EduProjectService } from 'src/app/service/context/edu/edu-project.service';
import { EduCategoryService } from 'src/app/service/context/edu/edu-category.service';
import { FileInfo, SelectedEventArgs, UploaderComponent } from '@syncfusion/ej2-angular-inputs';
import { RemoveUnicode } from 'src/app/admin/shared/ultils';

@Component({
    selector: 'app-edu-project-edit',
    templateUrl: './edu-project-edit.component.html',
    styles: []
})
export class EduProjectEditComponent implements OnInit {
    constructor(
        private eduCategoryService: EduCategoryService,
        private eduProjectService: EduProjectService,
        private modalService: BsModalService,
        private toastr: ToastrService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    // Cơ bản
    guid: string;
    eduProject: any = {
        status: 1,
    };
    categorySelected: any = {};

    types: any[] = [];
    eduCategories: any[] = [];
    linkDownloadSubModal: string;
    editorConfig: AngularEditorConfig = {};
    changeLinkDownloadSubModal: boolean = false;

    // Ảnh
    @ViewChild('defaultupload')
    uploadObj: UploaderComponent;
    eduProjectImages: any[] = [];
    dropEle: HTMLElement;
    maxImage: number = 10;
    path: Object = {};
    host: string;

    // Phê duyệt
    comment: string;
    modalRef: BsModalRef;
    isApproving: boolean = false;
    approvalModal: boolean = false;
    eduProjectHisApprovals: any[] = [];
    isShowHisApproval: boolean = false;

    ngOnInit() {
        // Cơ bản
        this.editorConfig = {
            editable: true,
            spellcheck: true,
            height: '200px',
            minHeight: '0',
            maxHeight: 'auto',
            width: 'auto',
            minWidth: '0',
            translate: 'yes',
            enableToolbar: true,
            showToolbar: true,
            placeholder: 'Nhập nội dung...',
            defaultParagraphSeparator: '',
            defaultFontName: '',
            defaultFontSize: '',
            fonts: [
                { class: 'arial', name: 'Arial' },
                { class: 'times-new-roman', name: 'Times New Roman' },
                { class: 'calibri', name: 'Calibri' },
                { class: 'comic-sans-ms', name: 'Comic Sans MS' }
            ],
            customClasses: [
                {
                    name: 'quote',
                    class: 'quote',
                },
                {
                    name: 'redText',
                    class: 'redText'
                },
                {
                    name: 'titleText',
                    class: 'titleText',
                    tag: 'h1',
                },
            ],
            sanitize: true,
            toolbarPosition: 'top'
        };
        this.guid = this.route.snapshot.paramMap.get('guid');
        this.loadDataListCategory();
        this.loadType();

        // Ảnh
        this.dropEle = document.getElementById('droparea');
        this.host = this.eduProjectService.BaseHost;

        if (this.guid) {
            this.loadData();
            this.loadDataProjectImage();

            this.loadDataHisApproval();
        }
    }

    // Cơ bản
    loadDataListCategory() {
        this.eduCategories = [];
        this.eduCategoryService.getListEduCategory().subscribe(
            res => {
                let cats = (<any>res);

                cats.sort((a, b) => a['treeLevel'] - b['treeLevel'] || <any>new Date(b['createdAt']) - <any>new Date(a['createdAt']));
                for (const catParent of cats.filter(x => !x.guidParent)) {
                    catParent.children = cats.filter((x) => x.guidParent == catParent.guid);

                    for (const menuChild of catParent.children) {
                        menuChild.children = cats.filter((x) => x.guidParent == menuChild.guid);
                    }

                    this.eduCategories.push(catParent);
                }
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    loadType() {
        this.eduProjectService.getListType().subscribe(
            res => {
                this.types = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    loadData() {
        this.eduProjectService.getEduProjectById(this.guid).subscribe(
            res => {
                if (!res)
                    this.router.navigateByUrl('/techbyte/admin/error');

                this.eduProject = <any>res;

                this.linkDownloadSubModal = this.eduProject.linkDownloadSub;

                this.eduCategoryService.getEduCategoryById(this.eduProject.eduCategoryGuid).subscribe(
                    res => {
                        if (!res)
                            this.router.navigateByUrl('/techbyte/admin/error');

                        this.categorySelected = <any>res;
                    },
                    err => {
                        this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                    },
                );
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onSave() {
        this.eduProject.seoFriendUrl = RemoveUnicode(this.eduProject.title);
        this.eduProject.eduCategoryGuid = this.categorySelected.guid;
        if (!this.eduProject.salePrice) this.eduProject.salePrice = 0;

        let uploadFiles = this.uploadObj.getFilesData();
        const formData = new FormData();
        for (var i = 0; i < uploadFiles.length; i++) {
            var fileToUpload = uploadFiles[i];
            formData.append('file', fileToUpload.rawFile, fileToUpload.name);
        }

        document.getElementById('page-loader-data').style.display = "block";
        this.eduProjectService.saveEduProject(this.eduProject, formData).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.router.navigateByUrl('/techbyte/admin/edu-project');
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    onCancel() {
        this.router.navigateByUrl('/techbyte/admin/edu-project');
    }

    uploadDrive = (files) => {
        if (files.length === 0) {
            return;
        }

        let fileToUpload = <File>files[0];
        const formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);

        this.toastr.info("Đang tải lên...");
        var forms = document.getElementsByClassName("tile");
        for (var i = 0; i < forms.length; i++) {
            forms[i].classList.add('refreshing');
        }
        document.querySelectorAll('.tile button').forEach(elem => {
            (<any>elem).disabled = true;
        });
        document.querySelectorAll('.tile a').forEach(elem => {
            (<any>elem).style.display = 'none';
        });
        document.getElementById('page-loader-data').style.display = "block";
        this.eduProjectService.uploadDrive(formData).subscribe({
            next: (event) => {
                if (event.type === HttpEventType.Response) {
                    if (event.body) {
                        this.toastr.clear();
                        this.toastr.success("Tải lên thành công !");

                        this.eduProject.fileName = (<any>event.body).fileName;
                        this.eduProject.linkDownload = (<any>event.body).path;

                        for (var i = 0; i < forms.length; i++) {
                            forms[i].classList.remove('refreshing');
                        }
                        document.querySelectorAll('.tile button').forEach(elem => {
                            (<any>elem).disabled = false;
                        });
                        document.querySelectorAll('.tile a').forEach(elem => {
                            (<any>elem).style.display = 'block';
                        });
                        document.getElementById('page-loader-data').style.display = "none";
                    }
                }
            },
            error: (err: HttpErrorResponse) => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');

                for (var i = 0; i < forms.length; i++) {
                    forms[i].classList.remove('refreshing');
                }
                document.querySelectorAll('.tile button').forEach(elem => {
                    (<any>elem).disabled = false;
                });
                document.querySelectorAll('.tile a').forEach(elem => {
                    (<any>elem).style.display = 'block';
                });
                document.getElementById('page-loader-data').style.display = "none";
            }
        });
    }

    uploadFeatureImage = (files) => {
        if (files.length === 0) {
            return;
        }

        let fileToUpload = <File>files[0];
        const formData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);

        this.toastr.info("Đang tải lên...");
        var forms = document.getElementsByClassName("tile");
        for (var i = 0; i < forms.length; i++) {
            forms[i].classList.add('refreshing');
        }
        document.querySelectorAll('.tile button').forEach(elem => {
            (<any>elem).disabled = true;
        });
        document.querySelectorAll('.tile a').forEach(elem => {
            (<any>elem).style.display = 'none';
        });
        document.getElementById('page-loader-data').style.display = "block";
        this.eduProjectService.uploadFeatureImage(formData).subscribe({
            next: (event) => {
                if (event.type === HttpEventType.Response) {
                    if (event.body) {
                        this.toastr.clear();
                        this.toastr.success("Tải lên thành công !");

                        this.eduProject.featureImage = (<any>event.body).path;

                        for (var i = 0; i < forms.length; i++) {
                            forms[i].classList.remove('refreshing');
                        }
                        document.querySelectorAll('.tile button').forEach(elem => {
                            (<any>elem).disabled = false;
                        });
                        document.querySelectorAll('.tile a').forEach(elem => {
                            (<any>elem).style.display = 'block';
                        });
                        document.getElementById('page-loader-data').style.display = "none";
                    }
                }
            },
            error: (err: HttpErrorResponse) => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');

                for (var i = 0; i < forms.length; i++) {
                    forms[i].classList.remove('refreshing');
                }
                document.querySelectorAll('.tile button').forEach(elem => {
                    (<any>elem).disabled = false;
                });
                document.querySelectorAll('.tile a').forEach(elem => {
                    (<any>elem).style.display = 'block';
                });
                document.getElementById('page-loader-data').style.display = "none";
            }
        });
    }

    // Ảnh
    onRefreshImage() {
        this.loadDataProjectImage();
    }

    loadDataProjectImage() {
        this.eduProjectService.getListProjectImage(this.guid).subscribe(
            res => {
                this.eduProjectImages = <any>res;

                this.maxImage = 10 - this.eduProjectImages.length;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRemoveImage(guid) {
        if (confirm("Hành động này sẽ xóa vĩnh viễn bản ghi này. Bạn có muốn thực hiện ?")) {
            this.eduProjectService.deleteEduProjectImage(guid).subscribe(
                res => {
                    this.toastr.success("Thành công");
                    this.loadDataProjectImage();
                },
                err => {
                    this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                },
            );
        }
    }

    onFileSelected(args: SelectedEventArgs): void {
        args.filesData.splice(this.maxImage);
        let filesData: FileInfo[] = this.uploadObj.getFilesData();
        let allFiles: FileInfo[] = filesData.concat(args.filesData);
        if (allFiles.length > this.maxImage) {
            this.toastr.error('Tối đa 10 ảnh !', 'Lỗi.');
            args.filesData = filesData;
            // set the modified custom data
            args.modifiedFilesData = args.filesData;
        }
        args.isModified = true;
    }

    onChangeLinkDownloadSub(template: TemplateRef<any>) {
        this.approvalModal = false;
        this.changeLinkDownloadSubModal = true;

        this.linkDownloadSubModal = '';
        this.modalRef = this.modalService.show(template);
    }

    onDoneChangeLinkDownloadSub() {
        if (!this.linkDownloadSubModal) {
            this.toastr.error("Link download phụ không được để trống", 'Lỗi.');
            return;
        }

        let item = {
            guid: this.guid,
            linkDownloadSub: this.linkDownloadSubModal,
        };
        this.eduProjectService.changeLinkDownloadSubEduProject(item).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.modalRef.hide();
                window.location.reload();
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    // Phê duyệt
    onApprove(template: TemplateRef<any>) {
        this.approvalModal = true;
        this.changeLinkDownloadSubModal = false;

        this.comment = '';
        this.modalRef = this.modalService.show(template);
        this.isApproving = true;
    }

    onReject(template: TemplateRef<any>) {
        this.approvalModal = true;
        this.changeLinkDownloadSubModal = false;

        this.comment = '';
        this.modalRef = this.modalService.show(template);
        this.isApproving = false;
    }

    onDoneApproval() {
        if (this.isApproving == false && this.comment.length == 0) {
            this.toastr.error("Ý kiến phê duyệt không được để trống", 'Lỗi.');
            return;
        }

        let approvalItem = {
            eduProjectGuid: this.guid,
            comment: this.comment,
            isApproving: this.isApproving,
        };
        this.eduProjectService.approvalEduProject(approvalItem).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.modalRef.hide();
                window.location.reload();
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    loadDataHisApproval() {
        this.eduProjectService.getlistApprovalEduProject(this.guid).subscribe(
            res => {
                this.eduProjectHisApprovals = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefreshHisApproval() {
        this.loadDataHisApproval();
    }

    onMinimizeExpand() {
        this.isShowHisApproval = !this.isShowHisApproval;
    }
}